import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { AnimatePresence } from "framer-motion"

import { Animation } from 'components'
import { FaCheck } from 'react-icons/fa';

const Container = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0.3rem;
    padding: 0.2rem 0;
    cursor: ${props => !props.disabled && 'pointer'};
`

const Checkbox = styled.div`
    color: ${props => props.color || 'white'};
    background-color: ${props => props.backgroundColor || 'transparent'};
    border-color: ${props => props.borderColor || 'var(--secondary-accent-color)'};
    border-radius: 50%;
    /* border-radius: 5px; */
    border-width: 2px;
    border-style: solid;
    width: 0.7rem;
    height: 0.7rem;
    padding: 2px;
    font-size: 0.4rem;
    display: flex;
    justify-content: center;
    align-items: center;
    box-sizing: content-box;
`

const Indicator = styled.div`
    border-radius: 50%;
    background-color: ${props => props.value > 0.5 ? props.backgroundColor || 'var(--secondary-accent-color)' : 'var(--primary-color)'};
    background-image: ${props => props.value && `linear-gradient(to right, transparent 50%, ${props.value > 0.5 ? 'var(--primary-color)' : props.backgroundColor || 'var(--secondary-accent-color)'} 0)`};
    height: 100%;
    width: 100%;
    transform: ${props => props.value > 0.5 && 'rotateX(180deg) rotateY(180deg)'};

    :before {
        content: '';
        display: block;
        margin-left: 50%;
        height: 100%;
        border-radius: 0 100% 100% 0 / 50%;
        background: ${props => props.value > 0.5 ? props.backgroundColor || 'var(--secondary-accent-color)' : 'var(--primary-color)'};
        transform-origin: left;
        transform: ${props => props.value && `rotate(${props.value}turn)`};
    };
`

const Check = (props) => {
    const {
        backgroundColor,
        borderColor,
        color,
        filled,
        onSelect,
        disabled,
        value
    } = props;

    const [hover, setHover] = useState(false);
    return (
        <Container onClick={onSelect} onMouseEnter={() => setHover(!hover)} onMouseLeave={() => setHover(!hover)} disabled={disabled}>
            <Checkbox {...props}>
                <Indicator value={value}/>
            </Checkbox>
        </Container>
        
    )
}

export default Check;

Check.propTypes = {
    backgroundColor: PropTypes.string,
    borderColor: PropTypes.string,
    color: PropTypes.string,
    filled: PropTypes.bool,
    onSelect: PropTypes.func.isRequired,
}